module.exports = __webpack_public_path__ + "src/images/national-bricks-research-center.2d023f2434e35dfb617ff668ba00e6dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/national-bricks-research-center.jpg
// module id = 115
// module chunks = 0